import { createRouter, createWebHistory } from 'vue-router'

import store from '../store'
import utils from '../utils'

import Login from '../pages/Login'
import Profile from '../pages/Profile'
import ClientList from '../pages/ClientList'
import ClientForm from '../pages/ClientForm'
import PlaceList from '../pages/PlaceList'
import PlaceForm from '../pages/PlaceForm'
import ImplantList from '../pages/ImplantList'
import ImplantForm from '../pages/ImplantForm'
import OperationList from '../pages/OperationList'
import OperationForm from '../pages/OperationForm'
import DeadlineList from '../pages/DeadlineList'
import CallList from '../pages/CallList'
import CallForm from '../pages/CallForm'
import Calendar from '../pages/Calendar'
import Map from '../pages/Map'
import Import from '../pages/Import'
import DraftList from '../pages/DraftList'
import OrderList from '../pages/OrderList'
import OrderForm from '../pages/OrderForm'
import ProductList from '../pages/ProductList.vue'
import ProductForm from '../pages/ProductForm.vue'

import PathNotFound from '../pages/PathNotFound'

const routes = [
    {
        path: '/login',
        component: Login,
        name: 'Login'
    },
    {
        path: '/profile',
        component: Profile,
        name: 'Profilo'
    },
    {
        path: '/clienti',
        component: ClientList,
        name: 'Clienti',
        meta: {
            requiredAuthorization: true,
            roles: ['admin']
        }
    },
    {
        path: '/clienti/:id',
        component: ClientForm,
        name: 'Modifica cliente'
    },
    {
        path: '/clienti/new',
        component: ClientForm,
        name: 'Nuovo cliente',
        meta: {
            requiredAuthorization: true,
            roles: ['admin']
        }
    },
    {
        path: '/luoghi',
        component: PlaceList,
        name: 'Luoghi',
        meta: {
            requiredAuthorization: true,
            roles: ['admin']
        }
    },
    {
        path: '/luoghi/:id',
        component: PlaceForm,
        name: 'Modifica luogo'
    },
    {
        path: '/luoghi/new',
        component: PlaceForm,
        name: 'Nuovo luogo',
        meta: {
            requiredAuthorization: true,
            roles: ['admin']
        }
    },
    {
        path: '/impianti',
        component: ImplantList,
        name: 'Impianti',
        meta: {
            requiredAuthorization: true,
            roles: ['admin']
        }
    },
    {
        path: '/impianti/:id',
        component: ImplantForm,
        name: 'Modifica impianto'
    },
    {
        path: '/impianti/new',
        component: ImplantForm,
        name: 'Nuovo impianto',
        meta: {
            requiredAuthorization: true,
            roles: ['admin']
        }
    },
    {
        path: '/appuntamenti',
        component: OperationList,
        name: 'Appuntamenti'
    },
    {
        path: '/appuntamenti/:id',
        component: OperationForm,
        name: 'Modifica appuntamento'
    },
    {
        path: '/appuntamenti/new',
        component: OperationForm,
        name: 'Nuovo appuntamento',
        meta: {
            requiredAuthorization: true,
            roles: ['admin']
        }
    },
    {
        path: '/scadenze',
        component: DeadlineList,
        name: 'Scadenze',
        meta: {
            requiredAuthorization: true,
            roles: ['admin']
        }
    },
    {
        path: '/calendario',
        component: Calendar,
        name: 'Calendario'
    },
    {
        path: '/mappa',
        component: Map,
        name: 'Mappa',
        meta: {
            requiredAuthorization: true,
            roles: ['admin']
        }
    },
    {
        path: '/chiamate',
        component: CallList,
        name: 'Chiamate'
    },
    {
        path: '/chiamate/:id',
        component: CallForm,
        name: 'Modifica chiamata'
    },
    {
        path: '/chiamate/new',
        component: CallForm,
        name: 'Nuova chiamata'
    },
    {
        path: '/import',
        component: Import,
        name: 'Import'
    },
    {
        path: '/Bozze',
        component: DraftList,
        name: 'Bozze'
    },
    {
        path: '/ordini',
        component: OrderList,
        name: 'Ordini'
    },
    {
        path: '/ordini/:id',
        component: OrderForm,
        name: 'Modifica ordine'
    },
    {
        path: '/ordini/new',
        component: OrderForm,
        name: 'Nuovo ordine'
    },
    {
        path: '/magazzino',
        component: ProductList,
        name: 'Prodotti'
    },
    {
        path: '/magazzino/:id',
        component: ProductForm,
        name: 'Modifica prodotto'
    },
    {
        path: '/magazzino/new',
        component: ProductForm,
        name: 'Nuovo prodotto'
    },
    {
        path: '/',
        redirect: '/calendario'
    },
    {   path: '/:pathMatch(.*)*',
        component: PathNotFound
    },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
})

const DEFAULT_TITLE = import.meta.env.VITE_TITLE

router.beforeEach((to, from, next) => {
    // PAUSA TEMPORANEA: controllo modifiche non salvate disattivato per investigazione.
    // const fromFormName = utils.getGuardedFormNameByPath(from.path)
    // if (from.path !== to.path && fromFormName && utils.hasUnsavedForms(store, [fromFormName])) {
    //     const shouldLeave = window.confirm('Ci sono modifiche non salvate. Vuoi uscire senza salvare?')
    //     if (!shouldLeave) {
    //         return next(false)
    //     }
    // }

    if (to.name) {
        document.title = to.name + ' | ' + DEFAULT_TITLE
    } else {
        document.title = DEFAULT_TITLE
    }

    if (to.meta.requiredAuthorization && store.state.user) {
        if (to.meta?.roles?.includes('admin') && store.getters.amAdmin) {
            next()
        } else {
            next('/404')
        }
    } else {
        next()
    }
})

export default router